// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { QuickWinContentData } from "../schema";

export function serialize_QuickWinContentData_internal(value: QuickWinContentData): unknown {
  return ((
    value:
      | { quickWinType: "INSIGHT"; mcqCorrectAnswer: string; mcqFeedback: string; mcqOptions: string[]; mcqQuestion: string; script: string; takeaway: string }
      | { quickWinType: "REFLECTION"; mcqFeedback: string; mcqOptions: string[]; mcqQuestion: string; script: string; takeaway: string },
  ): unknown => {
    switch (value.quickWinType) {
      case "INSIGHT": {
        return {
          quickWinType: "INSIGHT",
          mcqCorrectAnswer: ((value: string): unknown => {
            return value;
          })(value["mcqCorrectAnswer"]),
          mcqFeedback: ((value: string): unknown => {
            return value;
          })(value["mcqFeedback"]),
          mcqOptions: ((value: string[]): unknown => {
            return value.map((value: string): unknown => {
              return value;
            });
          })(value["mcqOptions"]),
          mcqQuestion: ((value: string): unknown => {
            return value;
          })(value["mcqQuestion"]),
          script: ((value: string): unknown => {
            return value;
          })(value["script"]),
          takeaway: ((value: string): unknown => {
            return value;
          })(value["takeaway"]),
        };
      }
      case "REFLECTION": {
        return {
          quickWinType: "REFLECTION",
          mcqFeedback: ((value: string): unknown => {
            return value;
          })(value["mcqFeedback"]),
          mcqOptions: ((value: string[]): unknown => {
            return value.map((value: string): unknown => {
              return value;
            });
          })(value["mcqOptions"]),
          mcqQuestion: ((value: string): unknown => {
            return value;
          })(value["mcqQuestion"]),
          script: ((value: string): unknown => {
            return value;
          })(value["script"]),
          takeaway: ((value: string): unknown => {
            return value;
          })(value["takeaway"]),
        };
      }
    }
  })(value);
}
export function serialize_QuickWinContentData(obj: QuickWinContentData): string {
  return renderJsonWithNumbersAsBigint(serialize_QuickWinContentData_internal(obj));
}
export function deserialize_QuickWinContentData_internal(value: unknown): ParserResult<QuickWinContentData> {
  return ((
    value: unknown,
  ): ParserResult<
    | { quickWinType: "INSIGHT"; mcqCorrectAnswer: string; mcqFeedback: string; mcqOptions: string[]; mcqQuestion: string; script: string; takeaway: string }
    | { quickWinType: "REFLECTION"; mcqFeedback: string; mcqOptions: string[]; mcqQuestion: string; script: string; takeaway: string }
  > => {
    return ((
      value: unknown,
    ): ParserResult<
      | { quickWinType: "INSIGHT"; mcqCorrectAnswer: string; mcqFeedback: string; mcqOptions: string[]; mcqQuestion: string; script: string; takeaway: string }
      | { quickWinType: "REFLECTION"; mcqFeedback: string; mcqOptions: string[]; mcqQuestion: string; script: string; takeaway: string }
    > => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/QuickWinContentData]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/QuickWinContentData]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "quickWinType")) {
        return { success: false, reason: `[#/components/schemas/QuickWinContentData]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'quickWinType'.` };
      }
      if (typeof value["quickWinType"] != "string") {
        return { success: false, reason: `[#/components/schemas/QuickWinContentData]: '${value["quickWinType"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["quickWinType"];
      switch (discriminator) {
        case "INSIGHT": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            mcqCorrectAnswer: string;
            mcqFeedback: string;
            mcqOptions: string[];
            mcqQuestion: string;
            script: string;
            takeaway: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "mcqCorrectAnswer")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/mcqCorrectAnswer]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mcqCorrectAnswer'.` };
            }
            const parsed_mcqCorrectAnswer = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/mcqCorrectAnswer]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["mcqCorrectAnswer"]);
            })();
            if (!parsed_mcqCorrectAnswer.success) {
              return { success: false, reason: parsed_mcqCorrectAnswer.reason };
            }
            if (!hasProp(value, "mcqFeedback")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/mcqFeedback]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mcqFeedback'.` };
            }
            const parsed_mcqFeedback = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/mcqFeedback]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["mcqFeedback"]);
            })();
            if (!parsed_mcqFeedback.success) {
              return { success: false, reason: parsed_mcqFeedback.reason };
            }
            if (!hasProp(value, "mcqOptions")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/mcqOptions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mcqOptions'.` };
            }
            const parsed_mcqOptions = ((): ParserResult<string[]> => {
              return ((value: unknown): ParserResult<string[]> => {
                if (!isArray(value)) {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/mcqOptions]: '${value}' expected to be an array.` };
                }
                const parsed = value.map((value: unknown): ParserResult<string> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/mcqOptions]: '${value}' expected to be of type string.` };
                  }
                  return { success: true, value: value };
                });
                if (parsed.find((value) => !value.success) !== undefined) {
                  return {
                    success: false,
                    reason: `[#/components/schemas/QuickWinContentData/INSIGHT/mcqOptions]: Reason(s): '${parsed
                      .filter((p) => !p.success)
                      .map((p) => p.reason)
                      .join(", ")}'.`,
                  };
                }
                return {
                  success: true,
                  value: parsed.map((entry) => {
                    assert(entry.success == true);
                    return entry.value;
                  }),
                };
              })(value["mcqOptions"]);
            })();
            if (!parsed_mcqOptions.success) {
              return { success: false, reason: parsed_mcqOptions.reason };
            }
            if (!hasProp(value, "mcqQuestion")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/mcqQuestion]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mcqQuestion'.` };
            }
            const parsed_mcqQuestion = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/mcqQuestion]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["mcqQuestion"]);
            })();
            if (!parsed_mcqQuestion.success) {
              return { success: false, reason: parsed_mcqQuestion.reason };
            }
            if (!hasProp(value, "script")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/script]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'script'.` };
            }
            const parsed_script = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/script]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["script"]);
            })();
            if (!parsed_script.success) {
              return { success: false, reason: parsed_script.reason };
            }
            if (!hasProp(value, "takeaway")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/takeaway]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'takeaway'.` };
            }
            const parsed_takeaway = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/INSIGHT/takeaway]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["takeaway"]);
            })();
            if (!parsed_takeaway.success) {
              return { success: false, reason: parsed_takeaway.reason };
            }
            return {
              success: true,
              value: {
                mcqCorrectAnswer: parsed_mcqCorrectAnswer.value,
                mcqFeedback: parsed_mcqFeedback.value,
                mcqOptions: parsed_mcqOptions.value,
                mcqQuestion: parsed_mcqQuestion.value,
                script: parsed_script.value,
                takeaway: parsed_takeaway.value,
              },
            };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { quickWinType: "INSIGHT" as const, ...parsedVariant.value } };
        }
        case "REFLECTION": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            mcqFeedback: string;
            mcqOptions: string[];
            mcqQuestion: string;
            script: string;
            takeaway: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "mcqFeedback")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/mcqFeedback]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mcqFeedback'.` };
            }
            const parsed_mcqFeedback = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/mcqFeedback]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["mcqFeedback"]);
            })();
            if (!parsed_mcqFeedback.success) {
              return { success: false, reason: parsed_mcqFeedback.reason };
            }
            if (!hasProp(value, "mcqOptions")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/mcqOptions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mcqOptions'.` };
            }
            const parsed_mcqOptions = ((): ParserResult<string[]> => {
              return ((value: unknown): ParserResult<string[]> => {
                if (!isArray(value)) {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/mcqOptions]: '${value}' expected to be an array.` };
                }
                const parsed = value.map((value: unknown): ParserResult<string> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/mcqOptions]: '${value}' expected to be of type string.` };
                  }
                  return { success: true, value: value };
                });
                if (parsed.find((value) => !value.success) !== undefined) {
                  return {
                    success: false,
                    reason: `[#/components/schemas/QuickWinContentData/REFLECTION/mcqOptions]: Reason(s): '${parsed
                      .filter((p) => !p.success)
                      .map((p) => p.reason)
                      .join(", ")}'.`,
                  };
                }
                return {
                  success: true,
                  value: parsed.map((entry) => {
                    assert(entry.success == true);
                    return entry.value;
                  }),
                };
              })(value["mcqOptions"]);
            })();
            if (!parsed_mcqOptions.success) {
              return { success: false, reason: parsed_mcqOptions.reason };
            }
            if (!hasProp(value, "mcqQuestion")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/mcqQuestion]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mcqQuestion'.` };
            }
            const parsed_mcqQuestion = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/mcqQuestion]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["mcqQuestion"]);
            })();
            if (!parsed_mcqQuestion.success) {
              return { success: false, reason: parsed_mcqQuestion.reason };
            }
            if (!hasProp(value, "script")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/script]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'script'.` };
            }
            const parsed_script = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/script]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["script"]);
            })();
            if (!parsed_script.success) {
              return { success: false, reason: parsed_script.reason };
            }
            if (!hasProp(value, "takeaway")) {
              return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/takeaway]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'takeaway'.` };
            }
            const parsed_takeaway = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/QuickWinContentData/REFLECTION/takeaway]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["takeaway"]);
            })();
            if (!parsed_takeaway.success) {
              return { success: false, reason: parsed_takeaway.reason };
            }
            return { success: true, value: { mcqFeedback: parsed_mcqFeedback.value, mcqOptions: parsed_mcqOptions.value, mcqQuestion: parsed_mcqQuestion.value, script: parsed_script.value, takeaway: parsed_takeaway.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { quickWinType: "REFLECTION" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/QuickWinContentData]: '${discriminator}' expected to be one of 'INSIGHT, REFLECTION'.` };
      }
    })(value);
  })(value);
}
export function deserialize_QuickWinContentData(str: string): ParserResult<QuickWinContentData> {
  return deserialize_QuickWinContentData_internal(parseJsonWithNumbersAsBigint(str));
}
